"use client";
import { cn } from "@/lib/utils";
import React, { FC, PropsWithChildren, useEffect, useState } from "react";

const HeaderWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        className={cn(
          "w-full z-50 transition-all duration-300",
          {
            "fixed slide-down shadow-sm bg-white/95": isScrolled,
          },
          {
            "relative top-0 left-0": !isScrolled,
          },
        )}
      >
        {children}
      </header>
      {isScrolled && <div className="h-[64px] sm:h-[81px]"></div>}
    </>
  );
};

export default HeaderWrapper;
